import React, {createContext, useContext, useState, useEffect, useMemo} from 'react';
import {toast} from 'react-hot-toast';
import useLocalStorage from '../hooks/useLocalStorage';
import lang from "../JSON-FILES/lang.json"

const Context = createContext();

export const StateContext = ({children}) => {
    const [showCart, setShowCart] = useState(false);
    const [showLowbar, setShowLowbar] = useState(false);
    const [cartItems, setCartItems] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0);
    const [totalQuantities, setTotalQuantities] = useState(0);
    const [qty, setQty] = useState(1);

    const [customer, setCustomer] = useLocalStorage("customer")


    const [newCustomerProduct, setNewCustomerProduct] = useLocalStorage("newCustomerProduct")
    const [newSupplyCustomerProduct, setNewSupplyCustomerProduct] = useLocalStorage("newSupplyCustomerProduct")
    const [newNonConformity, setNewNonConformity] = useLocalStorage("newNonConformity")
    const [newRegisterTemplate, setNewRegisterTemplate] = useLocalStorage("newRegisterTemplate")
    const [newPresidioModule, setNewPresidioModule] = useLocalStorage("newPresidioModule")
    const [newUser, setNewUser] = useLocalStorage("newUser")
    const [newClient, setNewClient] = useLocalStorage("newClient")
    const [newSite, setNewSite] = useLocalStorage("newSite")


    const [client, setClient] = useLocalStorage("client")
    const [offer, setOffer] = useLocalStorage("offer")
    const [clientOrder, setClientOrder] = useLocalStorage("clientOrder")
    const [isEditingOffer, setIsEditingOffer] = useLocalStorage("isEditingOffer")
    const [site, setSite] = useLocalStorage("site")
    const [register, setRegister] = useLocalStorage("register")
    const [duplicateDevice, setDuplicateDevice] = useLocalStorage("duplicateDevice")
    const [subReasons, setSubReasons] = useLocalStorage("subReasons")
   // const [device, setDevice] = useState(undefined)
    const [deviceEdit, setDeviceEdit] = useState(false)
    const [loading, setLoading] = useState(false);

    const [customerUsers, setCustomerUsers] = useLocalStorage("customerUsers")
    const [registerTemplates, setRegisterTemplates] = useLocalStorage("registerTemplates");
    const [nonConformities, setNonConformities] = useLocalStorage("nonConformities");
    const [clients, setClients] = useLocalStorage("clients");
    const [sites, setSites] = useLocalStorage("sites");
    const [registers, setRegisters] = useLocalStorage("registers");
    const [devices, setDevices] = useLocalStorage("devices");
    const [mobileView, setMobileView] = useLocalStorage("mobileView");
    const [manualOffline, setManualOffline] = useLocalStorage("manualOffline");
    const [offlineData, setOfflineData] = useLocalStorage("offlineData");
    const [isWorksheet, setIsWorksheet] = useLocalStorage("worksheet")
    
    const [deviceNonConformities, setDeviceNonConformities] = useLocalStorage("deviceNonConformities");

    const [currentTemplate, setCurrentTemplate] = useLocalStorage("currentTemplate");
    const [currentDevice, setCurrentDevice] = useLocalStorage("currentDevice");

    const [defaultOfferMenu, setDefaultOfferMenu] = useLocalStorage("defaultOfferMenu")


    const [currentNonConformity, setCurrentNonConformity] = useState({});
    const [selectorVis, setSelectorVis] = useLocalStorage("selectorVis", true)

    const [excelData, setExcelData] = useLocalStorage("excelData");

    const [modalOpen, setModalOpen] = useState(false);
    const [forceLoad, setForceLoad] = useState(false);
    const [screenPosition, setScreenPosition] = useState(0);
    const [dropdownScreenPosition, setDropdownScreenPosition] = useState(0);
    const [modalContent, setModalContent] = useState(undefined);

    const [substituteDeviceId, setsubstituteDeviceId] = useState();

    const [sUser, setSUser] = useLocalStorage("user",undefined)
    const [bypassNewPassword, setBypassNewPassword] = useLocalStorage("bypassNewPassword", false)

    const LDB = (page, key) => {
        const sUserLanguage = !sUser?.language ? "it" : sUser?.language
        if(!key) return ""
        if(!page) return ""
        const langPage = lang[`${page}`]
        if(!langPage) return ""
        if(langPage[`${key}`]?.[`${sUserLanguage}`] == undefined) return ""

        return langPage[`${key}`][`${sUserLanguage}`]
    }

    const [searchTerm, setSearchTerm] = useState("");
    const [indexPage, setIndexPage] = useState("HOME");
    const [deviceIndexPage, setDeviceIndexPage] = useState("DEVICE")

    let foundProduct;
    let index;

    /** This function allows to add products to the cart
     * @param product
     * @param quantity
     *
    */
    const onAdd = (product, quantity) => {
        const checkProductInCart = !Array.isArray(cartItems) ? false : cartItems?.find?.((item) => item._id === product._id);

        setTotalPrice((prevTotalPrice) => prevTotalPrice + product.price * quantity);
        setTotalQuantities((prevTotalQuantities) => prevTotalQuantities + quantity);

        if (checkProductInCart) {
            const updatedCartItems = cartItems.map?.((cartProduct) => {
                if (cartProduct._id === product._id) 
                    return {
                        ...cartProduct,
                        quantity: cartProduct.quantity + quantity
                    }
                })

            setCartItems(updatedCartItems);
        } else {
            product.quantity = quantity;

            setCartItems([
                ...cartItems, {
                    ...product
                }
            ]);
        }

        toast.success(`${qty} ${product.name} added to the cart.`);
    }
    /** removes the product from the cart
   * @param product
  */

    const onRemove = (product) => {
        foundProduct = !Array.isArray(cartItems) ? undefined : cartItems?.find?.((item) => item._id === product._id);

        const newCartItems =  !Array.isArray(cartItems) ? [] : cartItems?.filter?.((item) => item._id !== product._id);

        setTotalPrice(
            (prevTotalPrice) => prevTotalPrice - foundProduct.price * foundProduct.quantity
        );
        setTotalQuantities(
            prevTotalQuantities => prevTotalQuantities - foundProduct.quantity
        );
        setCartItems(newCartItems);
    }

    /** This function allows the change of quantities from the cart
     * @param id
     * @param value
     * if value is 'inc' it increases, if value is 'dec' it decreases
    */
    const toggleCartItemQuanitity = (id, value) => {
        foundProduct = !Array.isArray(cartItems) ? undefined : cartItems?.find?.((item) => item._id === id)
        index = cartItems?.findIndex((product) => product._id === id);

        //const newCartItems = cartItems.filter?.((item) => item._id !== id)
        const newCartItems = [...cartItems];

        if (value === 'inc') {
            // setCartItems([...newCartItems, { ...foundProduct, quantity:
            // foundProduct.quantity + 1 } ]);
            foundProduct.quantity += 1;
            newCartItems[index] = foundProduct;
            setCartItems(newCartItems)

            setTotalPrice((prevTotalPrice) => prevTotalPrice + foundProduct.price)
            setTotalQuantities(prevTotalQuantities => prevTotalQuantities + 1)
        } else if (value === 'dec') {
            if (foundProduct.quantity > 1) {
                // setCartItems([...newCartItems, { ...foundProduct, quantity:
                // foundProduct.quantity - 1 } ]);
                foundProduct.quantity -= 1;
                newCartItems[index] = foundProduct
                setCartItems(newCartItems)

                setTotalPrice((prevTotalPrice) => prevTotalPrice - foundProduct.price)
                setTotalQuantities(prevTotalQuantities => prevTotalQuantities - 1)
            }
        }
    }
    /** This function increases the quantity of products */

    const incQty = () => {
        setQty((prevQty) => prevQty + 1);
    }

    /** This function decreaseases the quantity of products */
    const decQty = () => {
        setQty((prevQty) => {
            if (prevQty - 1 < 1) 
                return 1;
            
            return prevQty - 1;
        });
    }

    const forceReload = () => {
        setForceLoad(!forceLoad)
        console.log("force reload", !forceLoad)
    }

const apiUrl = useMemo( () => {
    const env = process.env.NODE_ENV
    let domain;
    if (typeof window !== 'undefined') {
      domain = window.location.origin;
    } else {
      domain = undefined;
    }
    if(env == "development"){
        //console.log("TEST ENV DEV", env, domain)
        // For development, always use localhost:8080 as the API URL
        return "http://localhost:8080"
    }
    else if (env == "production"){
        //console.log("TEST ENV PROD", env, domain)
        if(domain?.includes('beta.relyonfm.com')){
            return "https://beta-api.relyonfm.com"
        }
        return "https://apis.relyonfm.com"
    }
    return "http://localhost:8080" // fallback
}, [] )  

    return (
        <Context.Provider
            value={{
                showCart,
                setShowCart,
                apiUrl,
                cartItems,
                totalPrice,
                totalQuantities,
                qty,
                incQty,
                decQty,
                onAdd,
                toggleCartItemQuanitity,
                onRemove,
                setCartItems,
                setTotalPrice,
                setTotalQuantities,
                customer,
                setCustomer,
                showLowbar, 
                setShowLowbar,
                searchTerm,
                setSearchTerm,
                client,
                setClient,
                site,
                setSite,
                register,
                setRegister,
                //device,
                //setDevice,
                registerTemplates,
                setRegisterTemplates,
                clients, 
                setClients,
                sites, 
                setSites,
                registers, 
                setRegisters,
                currentTemplate,
                setCurrentTemplate,
                currentDevice,
                setCurrentDevice,
                currentNonConformity, 
                setCurrentNonConformity,
                devices, 
                setDevices,
                deviceEdit, 
                setDeviceEdit,
                modalOpen, 
                setModalOpen,
                modalContent,
                setModalContent,
                sUser, 
                setSUser,
                selectorVis, 
                setSelectorVis,
                nonConformities,
                setNonConformities,
                customerUsers, 
                setCustomerUsers,
                duplicateDevice,
                setDuplicateDevice,
                indexPage, 
                setIndexPage,
                loading, 
                setLoading,
                deviceNonConformities,
                setDeviceNonConformities,
                substituteDeviceId,
                setsubstituteDeviceId,
                deviceIndexPage, 
                setDeviceIndexPage,
                LDB,
                mobileView, 
                setMobileView,
                screenPosition, 
                setScreenPosition,
                offlineData, 
                setOfflineData,
                subReasons,
                setSubReasons,
                offer, 
                setOffer,
                isEditingOffer, 
                setIsEditingOffer,
                excelData,
                setExcelData,
                forceReload,
                forceLoad,
                defaultOfferMenu, 
                setDefaultOfferMenu,
                newCustomerProduct, 
                setNewCustomerProduct,
                newSupplyCustomerProduct, 
                setNewSupplyCustomerProduct,
                newNonConformity, 
                setNewNonConformity,
                newPresidioModule, 
                setNewPresidioModule,
                newRegisterTemplate, 
                setNewRegisterTemplate,
                newUser, 
                setNewUser,
                newClient, 
                setNewClient,
                newSite, 
                setNewSite,
                bypassNewPassword, 
                setBypassNewPassword,
                dropdownScreenPosition, 
                setDropdownScreenPosition,
                clientOrder, 
                setClientOrder,
                isWorksheet, 
                setIsWorksheet,
                manualOffline, 
                setManualOffline
            }}>
            {children}
        </Context.Provider>
    )
}

export const useStateContext = () => useContext(Context);
